// API base URL: em localhost usa backend local; em produção usa sempre a mesma origem (evita build com localhost)
const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
export const API_BASE = isLocalhost
  ? 'http://localhost:4000'
  : (typeof window !== 'undefined' ? window.location.origin : 'https://bot.tilti.io');
